import Vue from 'vue'

const TYPE_SPECIAL = 'special';
const TYPE_NOT_WORK = 'not_work';

export default {
	list({}, filter) {
		return Vue.api.post('agenda/list', {
			"per_page": filter.per_page || 20,
			"current_page": filter.current_page || 1,
			"type": [TYPE_SPECIAL, TYPE_NOT_WORK],
			"worker_ids": filter.worker_ids || []
		})
	},
	create({dispatch}, record) {
		if (record.id) {
			return dispatch('update', record)
		}

		record.type = [TYPE_SPECIAL]

		if (!record.isWork) {
			record.type.push(TYPE_NOT_WORK)
		}

		return Vue.api.post('agenda/', {
			"begin": record.begin,
			"end": record.end,
			"worker_ids": record.worker_ids,
			"clinic_id": record.clinic_id,
			"type": record.type,
			"_scenario": "special"
		})
	},
	update({}, record) {
		record.type = [TYPE_SPECIAL]

		if (!record.isWork) {
			record.type.push(TYPE_NOT_WORK)
		}

		return Vue.api.put('agenda/' + record.id, record)
	},
	get({}, id) {
		return Vue.api.get('agenda/' + id)
	},
	delete({}, id) {
		return Vue.api.delete('agenda/' + id)
	}
}



// WEBPACK FOOTER //
// ./src/vuex/services/special/actions.js